import apiService from './api/api.service';
import { logger } from '@utils/logger';

class DocumentService {
  /**
   * Upload document
   */
  async uploadDocument(documentType, file) {
    try {
      const formData = new FormData();
      formData.append('document', file);
      formData.append('documentType', documentType);

      const response = await apiService.post('/documents/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      logger.info('Document uploaded successfully', { documentType });
      return response;
    } catch (error) {
      logger.error('Document upload failed', error);
      throw error;
    }
  }

  /**
   * Get user's documents
   */
  async getMyDocuments() {
    try {
      const response = await apiService.get('/documents/my-documents');
      // API service wraps response, so actual data is in response.data.data or response.data
      if (response.success && response.data) {
        return {
          success: true,
          data: response.data.data || response.data
        };
      }
      return response;
    } catch (error) {
      logger.error('Failed to get documents', error);
      throw error;
    }
  }

  /**
   * Get pending documents (Admin only)
   */
  async getPendingDocuments(page = 1, limit = 20) {
    try {
      const response = await apiService.get('/documents/pending', {
        params: { page, limit }
      });
      return response;
    } catch (error) {
      logger.error('Failed to get pending documents', error);
      throw error;
    }
  }

  /**
   * Get document by ID
   */
  async getDocument(documentId) {
    try {
      const response = await apiService.get(`/documents/${documentId}`);
      return response;
    } catch (error) {
      logger.error('Failed to get document', error);
      throw error;
    }
  }

  /**
   * Download document
   */
  async downloadDocument(documentId) {
    try {
      const response = await apiService.get(`/documents/${documentId}/download`, {
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      logger.error('Failed to download document', error);
      throw error;
    }
  }

  /**
   * Approve document (Admin only)
   */
  async approveDocument(documentId, notes = null) {
    try {
      const response = await apiService.post(`/documents/${documentId}/approve`, {
        notes
      });
      logger.info('Document approved successfully');
      return response;
    } catch (error) {
      logger.error('Failed to approve document', error);
      throw error;
    }
  }

  /**
   * Reject document (Admin only)
   */
  async rejectDocument(documentId, reason, notes = null) {
    try {
      const response = await apiService.post(`/documents/${documentId}/reject`, {
        reason,
        notes
      });
      logger.info('Document rejected successfully');
      return response;
    } catch (error) {
      logger.error('Failed to reject document', error);
      throw error;
    }
  }

  /**
   * Get verification logs
   */
  async getVerificationLogs(userId = null) {
    try {
      const url = userId 
        ? `/documents/verification-logs/${userId}`
        : '/documents/verification-logs';
      const response = await apiService.get(url);
      return response;
    } catch (error) {
      logger.error('Failed to get verification logs', error);
      throw error;
    }
  }
}

export const documentService = new DocumentService();
export default documentService;
